// ABOUTME: Wrapper for a switch placed beside a labelled field in the same row.
// ABOUTME: Gives the switch the input's height so, bottom-aligned, it centres on the input rather than on label + input.

import { Box } from '@ds/coolshop';
import { PropsWithChildren } from 'react';

/** Height of the DS text/select input (the label sits above it). */
const FIELD_INPUT_HEIGHT = 40;

export const InlineToggle = ({ children }: PropsWithChildren) => (
    <Box display="flex" alignItems="center" height={FIELD_INPUT_HEIGHT} flexShrink={0}>
        {children}
    </Box>
);
